import { HttpContext, HttpContextToken } from '@angular/common/http';

/** Explicit credentials for requests that build a session before it is published. */
export const AUTH_SESSION_REQUEST = new HttpContextToken<{ token: string | null; companyId: string | null } | null>(
    () => null
);

export function authSessionContext(token: string | null = null, companyId: string | null = null): HttpContext {
    return new HttpContext().set(AUTH_SESSION_REQUEST, { token, companyId });
}
